import type { Subscription } from '../types/subscription';
import isTrialSubscription from './is-trial-subscription';

function hasTrialSubscription(subscriptions: Subscription[]): boolean {
  return subscriptions.some((subscription: Subscription) => isTrialSubscription(subscription));
}

export default hasTrialSubscription;
